const apiPrefixURL = process.env.REACT_APP_API_HOSTNAME
const prefixBillingApiURL = process.env.REACT_APP_API_BILLING
const prefixConversationApiURL = process.env.REACT_APP_API_CONVERSATION
const prefixVoucherApiURL = process.env.REACT_APP_API_VOUCHER
const prefixBeaconApiURL = process.env.REACT_APP_API_BEACON
const lambdaApiURL = process.env.REACT_APP_LAMBDA_API_URL
const managerServiceURL = process.env.REACT_APP_MANAGER_SERVICE_HOSTNAME
const voucherServiceURL = process.env.REACT_APP_VOUCHER_SERVICE_HOSTNAME

const version = 'v1'
const version2 = 'v2'

const helpUrl = `${apiPrefixURL}/_/helper`
const baseURL = `${apiPrefixURL}/${version}`
const baseURL2 = `${apiPrefixURL}/${version2}`
const lambdaApiURL2 = `${lambdaApiURL}/${version2}`
const billingApiURL = `${prefixBillingApiURL}/${version}/api`
const beaconApiURL = `${prefixBeaconApiURL}/${version}/api`
const conversationApiURL = `${prefixConversationApiURL}/${version}`
const voucherApiURL = `${prefixVoucherApiURL}/${version}/api`
const openAPIURL = process.env.REACT_APP_OPEN_API
const baseURLManagerService = `${managerServiceURL}`
const helperUrlManagerService = `${managerServiceURL}/_/helper`
const baseURLVoucherService = `${voucherServiceURL}`
const baseURLTrpcManagerService = `${managerServiceURL}/api/trpc`

export default {
  apiPrefixURL,
  version,
  apiURL: baseURL,
  apiURL2: baseURL2,
  apiURLManager: baseURLManagerService,
  apiURLVoucher: baseURLVoucherService,
  apiURLTrpcManager: baseURLTrpcManagerService,
  billingApiURL,
  beaconApiURL,
  conversationApiURL,
  voucherApiURL,
  openAPIURL,
  lambdaApiURL,
  lambdaApiURL2,
  managerServiceURL,
  googleAPI: process.env.REACT_APP_GOOGLE_API_KEY,
  invitationURL: process.env.INVITATION_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
  awsBucketUrl: process.env.REACT_APP_AWS_BUCKET_URL,
  healtCheck: helpUrl,
  cndUrl: process.env.REACT_APP_CDN_URL,
  apiSocket: process.env.REACT_APP_API_SOCKET,
  healtCheckManager: helperUrlManagerService,
}
